import { useState } from 'react';

// A small icon button that copies `text` to the clipboard and shows a tick for a moment so
// the click is seen to have worked. `label` names what is being copied in the tooltip.
// `size` is the icon size in pixels; `light` styles it for a dark (navy) background.
export default function CopyButton({ text, label = 'Copy to clipboard', size = 13, light = false, className = '' }) {
  const [copied, setCopied] = useState(false);
  if (!text) return null;

  const copy = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  const colours = light
    ? 'text-white/60 hover:text-white hover:bg-white/15'
    : 'text-gray-400 hover:text-navy hover:bg-gray-100';

  return (
    <button
      type="button"
      onClick={copy}
      title={copied ? 'Copied' : label}
      aria-label={label}
      className={`flex-shrink-0 p-0.5 rounded transition-colors ${colours} ${className}`}
    >
      {copied
        ? <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="text-emerald-500"><polyline points="20 6 9 17 4 12"/></svg>
        : <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
      }
    </button>
  );
}
